// tslint:disable
export namespace BroadcastApi {
  export interface SelectOption {
    label: string;
    value: string;
  }
  export interface DataTemplateTag {
    tag: string;
    description?: string;
  }
  export enum TransmissionDirectAttachmentTypeEnum {
    TransmissionDirectAttachment = 'TransmissionDirectAttachment'
  }
  export enum ApiRequestDefinitionsVerbEnum {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE'
  }
  export interface ApiRequestDefinitions {
    verb: BroadcastApi.ApiRequestDefinitionsVerbEnum;
    url: string;
    payloadFactory?: any;
    responseAssignTarget?: string;
    responseAssignSource?: string;
  }
  export enum TransmissionDirectAttachmentChannelsEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface TransmissionDirectAttachment {
    type: BroadcastApi.TransmissionDirectAttachmentTypeEnum;
    attachment: BroadcastApi.ApiRequestDefinitions;
    channels: Array<BroadcastApi.TransmissionDirectAttachmentChannelsEnum>;
  }
  export enum TransmissionReportAttachmentServiceTypeEnum {
    reports = 'reports',
    reportsNew = 'reportsNew',
    loansRegulatoryReporting = 'loansRegulatoryReporting'
  }
  export enum TransmissionReportAttachmentTypeEnum {
    TransmissionReportAttachment = 'TransmissionReportAttachment'
  }
  export enum TransmissionReportAttachmentChannelsEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface TransmissionReportAttachment {
    id?: string;
    serviceType?: 'reports' | 'reportsNew' | 'loansRegulatoryReporting';
    type: BroadcastApi.TransmissionReportAttachmentTypeEnum;
    payloadFactory?: any;
    reportId: string;
    channels: Array<BroadcastApi.TransmissionReportAttachmentChannelsEnum>;
  }
  export enum TransmissionCreateDtoChannelsEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export enum MultiTransmissionApiRequestDefinitionsVerbEnum {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE'
  }
  export interface MultiTransmissionApiRequestDefinitions {
    verb: BroadcastApi.MultiTransmissionApiRequestDefinitionsVerbEnum;
    url: string;
    payloadFactory?: any;
    responseAssignTarget?: string;
    responseAssignSource?: string;
    transmissionPayloadFactory?: any;
  }
  export enum TransmissionTemplateChannelsEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface TransmissionTemplate {
    id?: string;
    attachmentsIdsToSend?: Array<string>;
    template?: string;
    sender: string;
    subject?: string;
    channels: Array<BroadcastApi.TransmissionTemplateChannelsEnum>;
    payloadFactory?: any;
  }
  export enum CreateAlertOnFailureCategoryEnum {
    Business = 'Business',
    System = 'System'
  }
  export interface CreateAlertOnFailure {
    category: BroadcastApi.CreateAlertOnFailureCategoryEnum;
    type?: string;
    code?: string;
  }
  export interface TransmissionCreateDto {
    name: string;
    description?: string;
    tags?: Array<string>;
    instruction?: string;
    active?: boolean;
    requiresLinkedEntity?: boolean;
    channels: Array<BroadcastApi.TransmissionCreateDtoChannelsEnum>;
    multiTransmissionApiRequest?: BroadcastApi.MultiTransmissionApiRequestDefinitions;
    preWebHookApiRequest?: BroadcastApi.ApiRequestDefinitions;
    actions?: Array<BroadcastApi.ApiRequestDefinitions>;
    templates?: Array<BroadcastApi.TransmissionTemplate>;
    attachments?: Array<BroadcastApi.TransmissionDirectAttachment | BroadcastApi.TransmissionReportAttachment>;
    postWebHookApiRequest?: BroadcastApi.ApiRequestDefinitions;
    data?: any;
    createAlertOnFailure?: BroadcastApi.CreateAlertOnFailure;
  }
  export enum TransmissionChannelsEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface Transmission {
    id: string;
    name: string;
    description?: string;
    tags?: Array<string>;
    instruction?: string;
    active?: boolean;
    requiresLinkedEntity?: boolean;
    channels: Array<BroadcastApi.TransmissionChannelsEnum>;
    templates: Array<BroadcastApi.TransmissionTemplate>;
    attachments: Array<BroadcastApi.TransmissionDirectAttachment | BroadcastApi.TransmissionReportAttachment>;
    multiTransmissionApiRequest?: BroadcastApi.MultiTransmissionApiRequestDefinitions;
    preWebHookApiRequest?: BroadcastApi.ApiRequestDefinitions;
    actions?: Array<BroadcastApi.ApiRequestDefinitions>;
    postWebHookApiRequest?: BroadcastApi.ApiRequestDefinitions;
    data: any;
    createDate: string;
    updateDate: string;
    version: number;
    owner: string;
    createAlertOnFailure?: BroadcastApi.CreateAlertOnFailure;
  }
  export enum TransmissionSearchRequestDtoChannelsEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface TransmissionSearchRequestDto {
    name?: string;
    exactNames?: Array<string>;
    active?: boolean;
    channels?:
      | 'NoopBroadcastChannel'
      | 'EmailBroadcastChannel'
      | 'FtpBroadcastChannel'
      | 'HttpBroadcastChannel';
    instruction?: string;
    createDate?: string;
    updateDate?: string;
  }
  export enum TransmissionSearchResponseSortMetadataOrderByEnum {
    name = 'name',
    createDate = 'createDate',
    updateDate = 'updateDate'
  }
  export enum SortDirection {
    asc = 'asc',
    desc = 'desc'
  }
  export interface TransmissionSearchResponseSortMetadata {
    orderBy: BroadcastApi.TransmissionSearchResponseSortMetadataOrderByEnum;
    order: BroadcastApi.SortDirection;
  }
  export interface PagingDto {
    totalPages?: number;
    pageNumber?: number;
    totalRows?: number;
  }
  export interface TransmissionSearchResponse {
    sorting?: BroadcastApi.TransmissionSearchResponseSortMetadata;
    paging?: BroadcastApi.PagingDto;
    rows: Array<BroadcastApi.Transmission>;
  }
  export enum SubscriberCreateDtoChannelEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface EntityRef {
    type: string;
    refId: string;
    label: string;
  }
  export enum SubscriberRecipientEmailRecipientTypeEnum {
    To = 'To',
    Cc = 'Cc',
    Bcc = 'Bcc'
  }
  export interface SubscriberRecipient {
    id: string;
    emailRecipientType?: 'To' | 'Cc' | 'Bcc';
  }
  export interface SubscriberInstance {
    active: boolean;
    entity?: BroadcastApi.EntityRef;
    account?: BroadcastApi.EntityRef;
    data: any;
    recipients: Array<BroadcastApi.SubscriberRecipient>;
  }
  // Hand-added pending an api-gen refresh: the gateway swagger snapshot lags PublicApi master
  // (#64207). Customer Expose switch — External = exposed to lender, Internal = hidden. See Task #67454.
  export type SubscriberClassification = 'External' | 'Internal';
  export interface SubscriberCreateDto {
    name: string;
    transmissionId: string;
    tags?: Array<string>;
    channel: BroadcastApi.SubscriberCreateDtoChannelEnum;
    instances: Array<BroadcastApi.SubscriberInstance>;
    active: boolean;
    recipients: Array<BroadcastApi.SubscriberRecipient>;
    data: any;
    entity?: BroadcastApi.EntityRef;
    classification?: BroadcastApi.SubscriberClassification;
  }
  export enum SubscriberChannelEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface Subscriber {
    id: string;
    name: string;
    tags?: Array<string>;
    transmissionId: string;
    transmissionName: string;
    channel: BroadcastApi.SubscriberChannelEnum;
    owner: string;
    createDate: string;
    updateDate: string;
    version: number;
    instances: Array<BroadcastApi.SubscriberInstance>;
    active: boolean;
    entity?: BroadcastApi.EntityRef;
    data: any;
    recipients: Array<BroadcastApi.SubscriberRecipient>;
    activeInstances: number;
    scheduleState?: boolean;
    // Hand-added pending an api-gen refresh (see SubscriberClassification). Absent = exposed. Task #67454.
    classification?: BroadcastApi.SubscriberClassification;
  }
  export enum SubscriberSearchRequestDtoChannelsEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface SubscriberSearchRequestDto {
    name?: string;
    owner?: string;
    transmissionId?: string;
    transmissionInstruction?: string;
    entity?: BroadcastApi.EntityRef;
    channels?:
      | 'NoopBroadcastChannel'
      | 'EmailBroadcastChannel'
      | 'FtpBroadcastChannel'
      | 'HttpBroadcastChannel';
    active?: boolean;
    createDate?: string;
    updateDate?: string;
  }
  export enum SubscriberSearchResponseSortMetadataOrderByEnum {
    createDate = 'createDate',
    updateDate = 'updateDate'
  }
  export interface SubscriberSearchResponseSortMetadata {
    orderBy: BroadcastApi.SubscriberSearchResponseSortMetadataOrderByEnum;
    order: BroadcastApi.SortDirection;
  }
  export interface SubscriberSearchResponse {
    sorting?: BroadcastApi.SubscriberSearchResponseSortMetadata;
    paging?: BroadcastApi.PagingDto;
    rows: Array<BroadcastApi.Subscriber>;
  }
  export interface JobDataDto {
    parameters?: any;
    headers?: any;
    messageBody?: any;
  }
  export interface SubscriberSchedule {
    enabled?: boolean;
    cron: string;
    data?: BroadcastApi.JobDataDto;
    rowVersion?: string;
  }
  export interface Object {}
  export interface Message {
    id: string;
    subscriberId: string;
    correlationId: string;
    subscriberName: string;
    payload: any;
    log: Array<string>;
    errorList: Array<string>;
    hasError: boolean;
    createDate: string;
    updateDate: string;
    version: number;
  }
  export enum RecipientCreateDtoTypeEnum {
    DirectEmailRecipient = 'DirectEmailRecipient',
    DirectFtpRecipient = 'DirectFtpRecipient',
    ConnectionStringFtpRecipient = 'ConnectionStringFtpRecipient',
    DirectHttpRecipient = 'DirectHttpRecipient',
    ConnectionStringHttpRecipient = 'ConnectionStringHttpRecipient'
  }
  export interface DirectEmailRecipientCreateDto extends BroadcastApi.RecipientCreateBaseDto {
    name: string;
    active: boolean;
    tags?: Array<string>;
    type: BroadcastApi.RecipientCreateDtoTypeEnum;
    entity?: BroadcastApi.EntityRef;
    email: string;
  }
  export interface DirectFtpRecipientCreateDto extends BroadcastApi.RecipientCreateBaseDto {
    name: string;
    active: boolean;
    tags?: Array<string>;
    type: BroadcastApi.RecipientCreateDtoTypeEnum;
    entity?: BroadcastApi.EntityRef;
    host: string;
    port: number;
    username: string;
    password?: string;
    privateKeyBase64?: string;
    rootDir?: string;
  }
  export interface ConnectionStringFtpRecipientCreateDto extends BroadcastApi.RecipientCreateBaseDto {
    name: string;
    active: boolean;
    tags?: Array<string>;
    type: BroadcastApi.RecipientCreateDtoTypeEnum;
    entity?: BroadcastApi.EntityRef;
    connectionString: string;
    password?: string;
    rootDir?: string;
  }
  export interface DirectHttpRecipientCreateDto extends BroadcastApi.RecipientCreateBaseDto {
    name: string;
    active: boolean;
    tags?: Array<string>;
    type: BroadcastApi.RecipientCreateDtoTypeEnum;
    entity?: BroadcastApi.EntityRef;
    scheme: string;
    domain: string;
    path: string;
    method: string;
    port?: number;
    username?: string;
    password?: string;
    queryString?: string;
  }
  export interface ConnectionStringHttpRecipientCreateDto extends BroadcastApi.RecipientCreateBaseDto {
    name: string;
    active: boolean;
    tags?: Array<string>;
    type: BroadcastApi.RecipientCreateDtoTypeEnum;
    entity?: BroadcastApi.EntityRef;
    url: string;
    method: string;
  }
  export enum RecipientTypeEnum {
    DirectEmailRecipient = 'DirectEmailRecipient',
    DirectFtpRecipient = 'DirectFtpRecipient',
    ConnectionStringFtpRecipient = 'ConnectionStringFtpRecipient',
    DirectHttpRecipient = 'DirectHttpRecipient',
    ConnectionStringHttpRecipient = 'ConnectionStringHttpRecipient'
  }
  export interface DirectEmailRecipient extends BroadcastApi.RecipientBaseDto {
    id: string;
    type: BroadcastApi.RecipientTypeEnum;
    tags?: Array<string>;
    active: boolean;
    name: string;
    owner: string;
    version: number;
    entity: BroadcastApi.EntityRef;
    createDate: string;
    updateDate: string;
    email: string;
  }
  export interface DirectFtpRecipient extends BroadcastApi.RecipientBaseDto {
    id: string;
    type: BroadcastApi.RecipientTypeEnum;
    tags?: Array<string>;
    active: boolean;
    name: string;
    owner: string;
    version: number;
    entity: BroadcastApi.EntityRef;
    createDate: string;
    updateDate: string;
    host: string;
    port: number;
    username: string;
    password: string;
    privateKeyBase64: string;
    rootDir?: string;
  }
  export interface ConnectionStringFtpRecipient extends BroadcastApi.RecipientBaseDto {
    id: string;
    type: BroadcastApi.RecipientTypeEnum;
    tags?: Array<string>;
    active: boolean;
    name: string;
    owner: string;
    version: number;
    entity: BroadcastApi.EntityRef;
    createDate: string;
    updateDate: string;
    connectionString: string;
    password?: string;
    rootDir?: string;
  }
  export enum DirectHttpRecipientSchemeEnum {
    HTTP = 'HTTP',
    HTTPS = 'HTTPS'
  }
  export enum DirectHttpRecipientMethodEnum {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE'
  }
  export interface DirectHttpRecipient extends BroadcastApi.RecipientBaseDto {
    id: string;
    type: BroadcastApi.RecipientTypeEnum;
    tags?: Array<string>;
    active: boolean;
    name: string;
    owner: string;
    version: number;
    entity: BroadcastApi.EntityRef;
    createDate: string;
    updateDate: string;
    scheme: BroadcastApi.DirectHttpRecipientSchemeEnum;
    domain: string;
    path: string;
    method: BroadcastApi.DirectHttpRecipientMethodEnum;
    queryString?: string;
    port?: number;
    username?: string;
    password?: string;
  }
  export enum ConnectionStringHttpRecipientMethodEnum {
    GET = 'GET',
    POST = 'POST',
    PUT = 'PUT',
    PATCH = 'PATCH',
    DELETE = 'DELETE'
  }
  export interface ConnectionStringHttpRecipient extends BroadcastApi.RecipientBaseDto {
    id: string;
    type: BroadcastApi.RecipientTypeEnum;
    tags?: Array<string>;
    active: boolean;
    name: string;
    owner: string;
    version: number;
    entity: BroadcastApi.EntityRef;
    createDate: string;
    updateDate: string;
    url: string;
    method: BroadcastApi.ConnectionStringHttpRecipientMethodEnum;
  }
  export enum RecipientSearchRequestDtoChannelsEnum {
    NoopBroadcastChannel = 'NoopBroadcastChannel',
    EmailBroadcastChannel = 'EmailBroadcastChannel',
    FtpBroadcastChannel = 'FtpBroadcastChannel',
    HttpBroadcastChannel = 'HttpBroadcastChannel'
  }
  export interface RecipientSearchRequestDto {
    ids?: Array<string>;
    name?: string;
    entity?: BroadcastApi.EntityRef;
    channels?: Array<BroadcastApi.RecipientSearchRequestDtoChannelsEnum>;
    active?: boolean;
    createDate?: string;
    updateDate?: string;
  }
  export enum RecipientSearchResponseSortMetadataOrderByEnum {
    name = 'name',
    createDate = 'createDate',
    updateDate = 'updateDate'
  }
  export interface RecipientSearchResponseSortMetadata {
    orderBy: BroadcastApi.RecipientSearchResponseSortMetadataOrderByEnum;
    order: BroadcastApi.SortDirection;
  }
  export interface RecipientSearchResponse {
    sorting?: BroadcastApi.RecipientSearchResponseSortMetadata;
    paging?: BroadcastApi.PagingDto;
    rows?: Array<
      | BroadcastApi.DirectEmailRecipient
      | BroadcastApi.DirectFtpRecipient
      | BroadcastApi.ConnectionStringFtpRecipient
      | BroadcastApi.DirectHttpRecipient
      | BroadcastApi.ConnectionStringHttpRecipient
    >;
  }
  export interface MessageSearchRequestDto {
    subscriberIds?: Array<string>;
    hasError?: boolean;
    createDate?: string;
    updateDate?: string;
  }
  export enum MessageSearchResponseSortMetadataOrderByEnum {
    createDate = 'createDate',
    updateDate = 'updateDate'
  }
  export interface MessageSearchResponseSortMetadata {
    orderBy: BroadcastApi.MessageSearchResponseSortMetadataOrderByEnum;
    order: BroadcastApi.SortDirection;
  }
  export interface MessageSearchResponse {
    sorting?: BroadcastApi.MessageSearchResponseSortMetadata;
    paging?: BroadcastApi.PagingDto;
    rows: Array<BroadcastApi.Message>;
  }
  export interface UpsertTemplateSpecificRecipientDto {
    templateId: string;
    recipientIds: Array<string>;
  }
  export interface SearchTemplateSpecificRecipientsDto {
    templateId: string;
    transmissionId: string;
  }
  export interface TemplateSpecificRecipientDto {
    id: string;
    name: string;
    selected: boolean;
  }
  export interface RecipientBaseDto {}
  export interface RecipientCreateBaseDto {}
}
